module.exports = __webpack_public_path__ + "media/images/players/HATTON_TYRELL-f954985f4bcaf1ddf57c38ab605e8f79.png";